import { InjectionToken } from '@angular/core'
import { BaseQuickActionProvider } from '../models/base-quick-action-provider.model'

export const QUICK_ACTION_PROVIDER: InjectionToken<string> =
	new InjectionToken<BaseQuickActionProvider>('QUICK_ACTION_PROVIDER')
